module.exports = __webpack_public_path__ + "img/ic_design_item3.569300cb.png";